/** Copyright 2025 SAP SE or an SAP affiliate company. All rights reserved. */
import TableLayout from '@/components/TableLayout/TableLayout';
import AdditionalUserLayout from '@/components/additionalUser/AdditionalUserLayout';
import DbLayout from './DbLayout';
import TaskLayout from '../components/TaskLayout';
import Final from '../components/Final';
import Review from '../components/Review';
import CommodityCodeLayout from '../components/CommodityCode/CommodityCodeLayout';
import SuccessMeasures from '../components/successMeasures/SuccessMeasures';
import CompanyInformation from '../components/companyInformation/CompanyInformation';
import BestPracticeTemplateForSourcing from '../components/bestPracticeTemplate/BestPracticeTemplateForSourcing';
import BestPracticeTemplateFor42k from '../components/bestPracticeTemplate/BestPracticeTemplateFor42k';
import VideoIframe from '../components/videoPlayer/VideoIframe';
import { useAppSelector } from '@/hooks';
import SupplierLevel from '@/components/supplierLevel/SupplierLevel';
import IllustrationImage from '@/components/IllustrationImage';

// make references to the components by type
// make sure it matches with task control type in backend
const ControlTypes = {
    TableLayout: TableLayout,
    taskLayout: TaskLayout,
    finalLayout: Final,
    reviewLayout: Review,
    dbLayout: DbLayout,
    AdditionalUser: AdditionalUserLayout,
    CommodityCodeLayout: CommodityCodeLayout,
    SuccessMeasures: SuccessMeasures,
    CompanyInformation: CompanyInformation,
    Experience: BestPracticeTemplateForSourcing,
    BestPractices: BestPracticeTemplateFor42k,
    supplierLevel: SupplierLevel,
    IllustrationImage: IllustrationImage,
};

type controlProps = {
    type: keyof typeof ControlTypes;
    videoHelpLink?: string;
    translationTitleKey?: string;
    description?: string;
    step?: {
        translationTitleKey?: string;
    };
};

export const ControlMapper = (props: controlProps) => {
    const Component = ControlTypes[props.type];
    const updatedProps = { ...props };
    const productList = useAppSelector(state => state.productList);

    const src = props.videoHelpLink ?? '';
    const title = props.step?.translationTitleKey ?? '';
    const description = props.description ?? '';

    return src && productList.showHelpVideo ? (
        <VideoIframe src={src} title={title} description={description} videoH="350px" />
    ) : (
        <Component content={updatedProps} />
    );
};
export default ControlMapper;
